<template>
    <WizardContainer
        :title="$t('funnel.unlayerEmail.unifiedFlow.modal.title')"
        :current-stage-index="wizardStageIndex"
        :app-id="appId"
        :user-id="userId"
        @go-to-stage="(index) => wizardStageIndex = index"
        @close="$emit('close')"
    >
        <template #header>
            <PortalTarget name="confirmation-email-header-actions" />
        </template>

        <template #select>
            template selection stage - not implemented
        </template>

        <template #edit>
            <EditStage
                :app-id="appId"
                :user-id="userId"
                :environment="environment"
                :design="design"
                @design-updated="$emit('design-updated', $event)"
            />
        </template>
    </WizardContainer>
</template>

<script>
import WizardContainer from './UnlayerEmailWizardContainer.vue';
import EditStage from './ConfirmationEmailEditStage.vue';

import {
    UNLAYER_EMAIL_BROADCAST_WIZARD_STAGE_INDEXES as STAGE_INDEXES,
} from '@/components/unlayer/constants/unlayer.constants';

export default {
    components: {
        WizardContainer,
        EditStage,
    },

    props: {
        appId: String,
        userId: [Number, String],
        design: Object,
        environment: String,
    },

    data() {
        return {
            wizardStageIndex: STAGE_INDEXES.CREATE,
        };
    },
}
</script>
